import { CredentialData } from './types';  
import { handleApiResponse } from '../common';
import { getApiBaseUrl, API_VERSION } from '../index';

const formatCredentialFields = (fields) => {
  console.log('Formatting credential fields:', fields);
  return Object.entries(fields).reduce((acc, [key, value]) => {
    acc[key] = {
      value: value.value,
      field_type: value.field_type || 'string',
      secure: value.secure === 'true' || value.secure === true
    };
    return acc;
  }, {});
};

export const credentialsApi = {
  async list() {
    console.log('Credentials API - list() called');
    console.log('API Base URL:', getApiBaseUrl());
    console.log('API Version:', API_VERSION);
    console.log('Full URL:', `${getApiBaseUrl()}${API_VERSION}/credentials`);
    console.log('Actual fetch URL:', new URL(`${getApiBaseUrl()}${API_VERSION}/credentials`, window.location.origin).href);    
    
    console.log('URL Components:', {
        baseUrl: getApiBaseUrl(),
        apiVersion: API_VERSION,
        url: `${getApiBaseUrl()}${API_VERSION}/credentials`,
        windowLocation: window.location.href,
        windowOrigin: window.location.origin
    });
    
    try {
        const request = new Request(`${getApiBaseUrl()}${API_VERSION}/credentials`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            credentials: 'include'
        });
        console.log('Request URL before fetch:', request.url);
        
        const response = await fetch(request);
        console.log('List credentials response:', {
            status: response.status,
            statusText: response.statusText,
            url: response.url
        });
        console.log('Response details:', {
            ok: response.ok,
            status: response.status,
            statusText: response.statusText,
            url: response.url
        });

        const validatedResponse = await handleApiResponse(response);
        const data = await validatedResponse.json();

        if (!data.credentials || !Array.isArray(data.credentials)) {
            console.error('Invalid data format:', data);
            throw new Error('Invalid data format received from API');
        }

        const transformedData = CredentialData.fromApiResponseList(data.credentials);
        return transformedData;
    } catch (error) {
        console.error('Failed to fetch credentials:', error);
        throw error;
    }
  },

  async getByToolName(toolName) {
    console.log('Getting credential for tool:', toolName);
    try {
      const response = await fetch(`${getApiBaseUrl()}${API_VERSION}/credentials/${toolName}`, {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        credentials: 'include',
      });

      const validatedResponse = await handleApiResponse(response);
      const data = await validatedResponse.json();
      return CredentialData.fromApiResponse(data);
    } catch (error) {
      console.error(`Failed to fetch credential for tool ${toolName}:`, error);
      throw error;
    }
  },

  async create(credentials) {
    console.log('Creating credential:', credentials);
    try {
      const credential = Array.isArray(credentials) ? credentials[0] : credentials;
      
      const formattedData = {
        tool_name: credential.tool_name,
        fields: formatCredentialFields(credential.fields)
      };

      console.log('Formatted credential data:', formattedData);

      const response = await fetch(`${getApiBaseUrl()}${API_VERSION}/credentials`, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify(formattedData)
      });

      const validatedResponse = await handleApiResponse(response);
      const data = await validatedResponse.json();
      return CredentialData.fromApiResponse(data);
    } catch (error) {
      console.error('Failed to create credential:', error);
      throw error;
    }
  },

  async update(credential) {
    console.log('Updating credential:', credential);
    try {
      const formattedData = {
        fields: formatCredentialFields(credential.fields)
      };

      const response = await fetch(`${getApiBaseUrl()}${API_VERSION}/credentials/${credential.tool_name}`, {
        method: 'PATCH',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify(formattedData)
      });

      const validatedResponse = await handleApiResponse(response);
      const data = await validatedResponse.json();
      return CredentialData.fromApiResponse(data);
    } catch (error) {
      console.error(`Failed to update credential ${credential.tool_name}:`, error);
      throw error;
    }
  },

  async delete(toolName) {
    console.log('Deleting credential:', toolName);
    try {
      const response = await fetch(`${getApiBaseUrl()}${API_VERSION}/credentials/${toolName}`, {
        method: 'DELETE',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        credentials: 'include'
      });

      const validatedResponse = await handleApiResponse(response);
      const data = await validatedResponse.json();
      return data.message;
    } catch (error) {
      console.error(`Failed to delete credential ${toolName}:`, error);
      throw error;
    }
  },

  async bulkCreate(credentials) {
    console.log('Bulk creating credentials:', credentials);
    try {
      const results = [];
      for (const credential of credentials) {
        const result = await this.create(credential);
        results.push(result);
      }
      return results;
    } catch (error) {
      console.error('Failed to bulk create credentials:', error);
      throw error;
    }
  },

  async bulkUpdate(credentials) {
    console.log('Bulk updating credentials:', credentials);
    try {
      const results = [];
      for (const credential of credentials) {
        const result = await this.update(credential);
        results.push(result);
      }
      return results;
    } catch (error) {
      console.error('Failed to bulk update credentials:', error);
      throw error;
    }
  },

  async bulkDelete(toolNames) {
    console.log('Bulk deleting credentials:', toolNames);
    try {
      const results = [];
      for (const toolName of toolNames) {
        const result = await this.delete(toolName);
        results.push(result);
      }
      return results;
    } catch (error) {
      console.error('Failed to bulk delete credentials:', error);
      throw error;
    }
  }
};